import {
  ButtonComponent,
  DividerComponent,
  TextFieldComponent,
} from "@/components";
import React from "react";
import {
  CurrencyConverter,
  IMAGES,
  MOBILE_REGEX,
  WEB_COLORS,
} from "@/lib/constants";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import { useTranslations } from "next-intl";
const RightCard = ({
  formik,
  handleFieldChange,
  isError,
  errorMessage,
  product,
}) => {
  const t = useTranslations("Login");
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack
      m={{ xs: 1 }}
      px={2}
      gap={2}
      flexGrow={1}
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Typography variant="h3" fontSize={{ xs: 14, sm: 30 }}>
        {t("phonenumber")}
      </Typography>
      <TextFieldComponent
        shrink
        type="number"
        name="phone"
        maxLength={10}
        label={t("phone")}
        value={formik?.values?.phone}
        placeholder={t("phone")}
        errorMessage={formik?.errors?.phone}
        error={Boolean(formik?.touched?.phone && formik?.errors?.phone)}
        success={Boolean(formik?.touched?.phone && !formik?.errors?.phone)}
        onBlur={formik.handleBlur}
        onChange={(e) => {
          handleFieldChange(e, MOBILE_REGEX);
        }}
        size={`${isBelowMd ? "small" : ""}`}
      />
      <ButtonComponent
        toolTipTitle={t("loginttoltip")}
        type="submit"
        onClick={formik.handleSubmit}
        disabled={!(formik.isValid && formik.dirty)}
        size={`${isBelowMd ? "small" : ""}`}
      >
        {t("getotp")}
      </ButtonComponent>
      <Stack width={"100%"}>
        <FormControlLabel
          control={
            <Checkbox
              name="terms"
              checked={formik.values.terms}
              onChange={formik.handleChange}
            />
          }
          label={
            <Typography color={WEB_COLORS.textFadeColor} fontSize={14}>
              {t("termsandconditions")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_TERMS_AND_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("terms")}
              </a>{" "}
              {t("and")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("privacy")}
              </a>{" "}
              {t("consent")}
            </Typography>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              name="whatsapp"
              checked={formik.values.whatsapp}
              onChange={formik.handleChange}
            />
          }
          label={
            <Typography
              color={WEB_COLORS.textFadeColor}
              fontSize={14}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              {t("whatsapp")}{" "}
              <Image
                src={IMAGES.whatsApp}
                alt="whatsApp"
                height={25}
                width={25}
              />
            </Typography>
          }
        />
      </Stack>
      {product !== "credit-score" && (
        <Stack gap={3}>
          <DividerComponent />
          <Stack gap={0.5} px={1}>
            <Typography fontSize={14} color={WEB_COLORS.textFadeColor}>
              Personal Loan Rates & Fees:
            </Typography>
            <Stack px={2}>
              <List sx={{ listStyleType: "disc", color: WEB_COLORS.primary }}>
                <ListItem
                  disablePadding
                  sx={{ display: "list-item", fontSize: 14, py: 0.5 }}
                >
                  Loan Amount upto ₹ 7,00,000
                </ListItem>
                <ListItem
                  disablePadding
                  sx={{ display: "list-item", fontSize: 14, py: 0.5 }}
                >
                  Tenure: 12 to 36 months
                </ListItem>
                <ListItem
                  disablePadding
                  sx={{ display: "list-item", fontSize: 14, py: 0.5 }}
                >
                  Rate of Interest (ROI): Starting from 17.9% per year
                </ListItem>
                {/* <ListItem
                disablePadding
                sx={{ display: "list-item", fontSize: 14, py: 0.5 }}
              >
                Maximum APR: 45%
              </ListItem> */}
                <ListItem
                  disablePadding
                  sx={{ display: "list-item", fontSize: 14, py: 0.5 }}
                >
                  Processing Fee: 1.5% of loan amount + taxes as applicable
                </ListItem>
                <ListItem
                  disablePadding
                  sx={{ display: "list-item", fontSize: 14, py: 0.5 }}
                >
                  Tech/Document Charges: 1.0% of loan amount + taxes as
                  applicable
                </ListItem>
              </List>
            </Stack>
            <Grid
              spacing={2}
              container
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "8px",
                padding: "8px",
                marginTop: "8px",
              }}
            >
              <Grid item xs={12}>
                <Typography fontSize={14} color={WEB_COLORS.textFadeColor}>
                  Example:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    Loan Amount
                  </Typography>
                  <Typography color={WEB_COLORS.primary} fontWeight={"bold"}>
                    ₹ 1,00,000
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    Interest Rate
                  </Typography>
                  <Typography color={WEB_COLORS.primary} fontWeight={"bold"}>
                    18%
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    Tenure
                  </Typography>
                  <Typography color={WEB_COLORS.primary} fontWeight={"bold"}>
                    12 Months
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    Interest
                  </Typography>
                  <Typography color={WEB_COLORS.primary} fontWeight={"bold"}>
                    {CurrencyConverter(10016)}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    Processing Fee (incl. GST)
                  </Typography>
                  <Typography color={WEB_COLORS.primary} fontWeight={"bold"}>
                    {CurrencyConverter(1770)}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    Tech/Document Charges (incl. GST)
                  </Typography>
                  <Typography color={WEB_COLORS.primary} fontWeight={"bold"}>
                    {CurrencyConverter(1180)}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    Total Payable (includes EMI, Processing Fee, and
                    Tech/Document Charges)
                  </Typography>
                  <Typography color={WEB_COLORS.primary} fontWeight={"bold"}>
                    {CurrencyConverter(112966)}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Stack>
                  <Typography fontSize={12} color={"rgba(0, 65, 53, 0.48)"}>
                    EMI
                  </Typography>
                  <Typography
                    fontSize={16}
                    color={WEB_COLORS.primary}
                    fontWeight={"bold"}
                  >
                    {CurrencyConverter(9168)}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default RightCard;
